import cx from 'classnames';
import React from 'react';
import currency from '|/helpers/currency';
import { ReviewSummaryResponse } from '|/services/purchase-api';
import styles from './price-breakdown.module.css';
import useOrderSummaryVm from '../../use-order-summary-vm';

interface DiscountsBreakdownProps {
  summary: ReviewSummaryResponse;
}

const DiscountsBreakdown = ({ summary }: DiscountsBreakdownProps) => {
  const {
    totalDiscountsAmount: totalDiscounts,
    creditKarmaDiscount,
    creditKarmaAmountSaved,
    tradeBoostDiscount,
    tradeBoostAmountSaved,
    employeeDiscount,
    employeeDiscountAmount
  } = useOrderSummaryVm(summary);

  return (
    <>
      {tradeBoostDiscount && (
        <div className={cx(styles.itemRow, styles.greenText)}>
          <p className={styles.subItem}>Trade-in discount</p>
          <p className={styles.discountAmount}>-{currency(tradeBoostAmountSaved ?? 0)}</p>
        </div>
      )}

      {creditKarmaDiscount && (
        <div className={cx(styles.itemRow, styles.greenText)}>
          <p className={styles.subItem}>Credit Karma savings</p>
          <p className={styles.discountAmount}>-{currency(creditKarmaAmountSaved ?? 0)}</p>
        </div>
      )}

      {employeeDiscount && (
        <div className={cx(styles.itemRow, styles.greenText)}>
          <p className={styles.subItem}>Employee discount</p>
          <p className={styles.discountAmount}>-{currency(employeeDiscountAmount ?? 0)}</p>
        </div>
      )}

      {totalDiscounts > 0 && (
        <div className={cx(styles.itemRow, styles.greenText)}>
          <p className={styles.subItem}>Price reductions</p>
          <p className={styles.discountAmount}>-{currency(totalDiscounts ?? 0)}</p>
        </div>
      )}
    </>
  );
};

export default DiscountsBreakdown;
